export default function(value) {
    /**
     * Formats seconds to minutes and seconds
     * Example: 123 => 00:02:03
     * @param {String} value
     * @return {String}
     */
    const seconds = parseInt(value, 10);
    let minutes = (seconds / 60) ^ 0;
    if (seconds % 60 === 0) {
        return `${minutes} min`;
    }

    return `< ${minutes + 1} min`;
}
